import { render } from "./ItemContent.vue?vue&type=template&id=0876d880&ts=true"
import script from "./ItemContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemContent.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/item/ItemContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0876d880"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0876d880', __exports__)) {
    api.reload('0876d880', __exports__)
  }
  
  module.hot.accept("./ItemContent.vue?vue&type=template&id=0876d880&ts=true", () => {
    api.rerender('0876d880', render)
  })

}


export default __exports__